import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import Parse from "parse";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";

Parse.serverURL = process.env.REACT_APP_PARSE_SERVER_URL;
Parse.initialize(process.env.REACT_APP_PARSE_APP_ID);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
